module.exports = "<div class=\"enviromentAll\">\n    <summary-environment ng-if=\"vm.envDetail && vm.envDetail.environments\" [data]=\"vm.envDetail\"></summary-environment>\n    <environment-menu ng-if=\"vm.dbType && vm.envDetail\" [db-type]=\"vm.dbType\" [data]=\"vm.envDetail\"></environment-menu>\n    <ui-view ng-init=\"app.authorized.environment.settings\"></ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/environmentDetails/environmentDetails.tpl.html
// module id = 1744
// module chunks = 0